import React, { useState } from 'react';
import { CheckboxCard } from './CheckboxCard';
import styled from 'styled-components/macro';
import { Button, H4 } from '@snsw/react-component-library';

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  margin-bottom: 1rem;
  margin-top: 2rem;
`;

const Title = styled(H4)`
  flex: 1;
`;

const ToggleExpandAll = styled(Button)`
  a {
    font-size: 1rem;
    line-height: 1rem;
    text-decoration-line: underline;
    color: $color-secondary-blue;
  }
`;

export const GroupCheckboxCard = ({
  id,
  title,
  items = [],
  onChange = (item) => {},
  isChecked = (item) => false,
  getCardTitle = (item) => null,
  getDefaultContent = (item) => null,
  getExpandedContent = (item) => null,
  getId = (item) => '',
}) => {
  const [expandAll, setExpandAll] = useState(false);
  const handleToggleExpandAll = () => setExpandAll((prev) => !prev);

  return Array.isArray(items) && items.length > 0 ? (
    <>
      <TitleContainer>
        <Title>{title}</Title>
        <ToggleExpandAll variant="link" onClick={handleToggleExpandAll}>
          {expandAll ? 'Collapse' : 'Expand'} all
        </ToggleExpandAll>
      </TitleContainer>

      {items.map((item, index) => {
        return (
          <CheckboxCard
            key={index}
            id={getId(item)}
            title={getCardTitle(item)}
            defaultContent={getDefaultContent(item)}
            expandedContent={getExpandedContent(item)}
            onChange={() => {
              onChange(item);
            }}
            isChecked={isChecked(item)}
            expanded={expandAll}
            hasError={item.hasError}
            errorMessage={item.errorMessage}
          />
        );
      })}
    </>
  ) : null;
};
